import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchCreditSegmentCodeTable, fetchCreditSegmentCodeById, addCreditSegmentCode, updateCreditSegmentCode, removeCreditSegmentCode } from "../../api/creditSegmentCodeApi";

// Async thunks for CreditSegmentCode operations

export const getCreditSegmentCodeTable = createAsyncThunk(
  "creditSegmentCode/getCreditSegmentCodeTable",
  async ({ page, limit }: { page: number; limit: number }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchCreditSegmentCodeTable(page, limit);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCreditSegmentCodeById = createAsyncThunk(
  "creditSegmentCode/getCreditSegmentCodeById",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchCreditSegmentCodeById(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createCreditSegmentCode = createAsyncThunk(
  "creditSegmentCode/createCreditSegmentCode",
  async (newCreditSegmentCode: { key: string; value: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addCreditSegmentCode(newCreditSegmentCode);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editCreditSegmentCode = createAsyncThunk(
  "creditSegmentCode/editCreditSegmentCode",
  async ({ id, updatedCreditSegmentCode }: { id: string; updatedCreditSegmentCode: any }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await updateCreditSegmentCode(id, updatedCreditSegmentCode);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCreditSegmentCode = createAsyncThunk(
  "creditSegmentCode/deleteCreditSegmentCode",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await removeCreditSegmentCode(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// CreditSegmentCode Slice

const creditSegmentCodeSlice = createSlice({
  name: "creditSegmentCode",
  initialState: {
    creditSegmentCodes: [] as any[],
    creditSegmentCode: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCreditSegmentCodeTable.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.creditSegmentCodes = action.payload;
      })
      .addCase(getCreditSegmentCodeTable.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      .addCase(getCreditSegmentCodeById.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.creditSegmentCode = action.payload;
      })
      .addCase(getCreditSegmentCodeById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      .addCase(createCreditSegmentCode.fulfilled, (state, action: PayloadAction<any>) => {
         // // // console.log(action.payload.data,'action.payload.data');
        
        state.creditSegmentCodes && state.creditSegmentCodes.length>0 && state.creditSegmentCodes.push(action.payload.data);
        state.status = true;
        state.msg = "Credit Segment Code created successfully.";
      })
      .addCase(editCreditSegmentCode.fulfilled, (state, action: PayloadAction<any>) => {
        // const { id, data } = action.payload;
        // const index = state.creditSegmentCodes.findIndex((code) => code.id === id);
        // if (index !== -1) {
        //   state.creditSegmentCodes[index] = data;
        // }
        state.status = true;
        state.msg = "Credit Segment Code updated successfully.";
      })
      .addCase(deleteCreditSegmentCode.fulfilled, (state, action: PayloadAction<string>) => {
        if( state.creditSegmentCodes && state.creditSegmentCodes.length>0 ){

            state.creditSegmentCodes =  state.creditSegmentCodes.filter((code) => code.id !== action.payload);
        }
        state.status = true;
        state.msg = "Credit Segment Code deleted successfully.";
      });
  },
});

export const { resetStatus } = creditSegmentCodeSlice.actions;
export default creditSegmentCodeSlice.reducer;